import { createContext } from "react";


const userContext = createContext();
const themeContext = createContext();
const languageContext = createContext();

export  {userContext, themeContext, languageContext};